// Legacy
export var PlaceTypeEnum;
(function (PlaceTypeEnum) {
    PlaceTypeEnum["COUNTRY"] = "country";
    PlaceTypeEnum["REGION"] = "region";
    PlaceTypeEnum["SUBREGION"] = "subregion";
    PlaceTypeEnum["DISTRICT"] = "district";
    PlaceTypeEnum["CITY"] = "city";
    PlaceTypeEnum["SUBCITY"] = "subcity";
    PlaceTypeEnum["ARRMUN"] = "arrmun";
    PlaceTypeEnum["BOROUGH"] = "borough";
    PlaceTypeEnum["NEIGHBORHOOD"] = "neighborhood";
    PlaceTypeEnum["IRIS"] = "iris";
    PlaceTypeEnum["STREET"] = "street";
    PlaceTypeEnum["BLOCK"] = "block";
    PlaceTypeEnum["PARCELLE"] = "parcelle";
    PlaceTypeEnum["BUILDING"] = "building";
    PlaceTypeEnum["ADDRESS"] = "address";
})(PlaceTypeEnum || (PlaceTypeEnum = {}));
export var PlaceTypePluralEnum;
(function (PlaceTypePluralEnum) {
    PlaceTypePluralEnum["COUNTRY"] = "countries";
    PlaceTypePluralEnum["REGION"] = "regions";
    PlaceTypePluralEnum["SUBREGION"] = "subregions";
    PlaceTypePluralEnum["DISTRICT"] = "districts";
    PlaceTypePluralEnum["CITY"] = "cities";
    PlaceTypePluralEnum["SUBCITY"] = "subcities";
    PlaceTypePluralEnum["ARRMUN"] = "arrmuns";
    PlaceTypePluralEnum["BOROUGH"] = "boroughs";
    PlaceTypePluralEnum["NEIGHBORHOOD"] = "neighborhoods";
    PlaceTypePluralEnum["IRIS"] = "irises";
    PlaceTypePluralEnum["STREET"] = "streets";
    PlaceTypePluralEnum["BLOCK"] = "blocks";
    PlaceTypePluralEnum["PARCELLE"] = "parcelles";
    PlaceTypePluralEnum["BUILDING"] = "buildings";
    PlaceTypePluralEnum["ADDRESS"] = "addresses";
})(PlaceTypePluralEnum || (PlaceTypePluralEnum = {}));
// V2
export var PlaceTypeNameEnum;
(function (PlaceTypeNameEnum) {
    PlaceTypeNameEnum["COUNTRY"] = "country";
    PlaceTypeNameEnum["MACROREGION"] = "macroregion";
    PlaceTypeNameEnum["REGION"] = "region";
    PlaceTypeNameEnum["MICROREGION"] = "microregion";
    PlaceTypeNameEnum["PROVINCE"] = "province";
    PlaceTypeNameEnum["COUNTY"] = "county";
    PlaceTypeNameEnum["MUNICIPALITY"] = "municipality";
    PlaceTypeNameEnum["BOROUGH"] = "borough";
    PlaceTypeNameEnum["MACRO_NEIGHBORHOOD"] = "macro_neighborhood";
    PlaceTypeNameEnum["NEIGHBORHOOD"] = "neighborhood";
    PlaceTypeNameEnum["MICRO_NEIGHBORHOOD"] = "micro_neighborhood";
    PlaceTypeNameEnum["MACRO_STAT_UNIT"] = "macro_stat_unit";
    PlaceTypeNameEnum["STATISTICAL_UNIT"] = "statistical_unit";
    PlaceTypeNameEnum["MICRO_STAT_UNIT"] = "micro_stat_unit";
    PlaceTypeNameEnum["STREET"] = "street";
    PlaceTypeNameEnum["BLOCK"] = "block";
    PlaceTypeNameEnum["PARCEL"] = "parcel";
    PlaceTypeNameEnum["BUILDING"] = "building";
    PlaceTypeNameEnum["HOUSE_NUMBER"] = "house_number";
})(PlaceTypeNameEnum || (PlaceTypeNameEnum = {}));
export var PlaceTypeKeyEnum;
(function (PlaceTypeKeyEnum) {
    PlaceTypeKeyEnum["COUNTRY"] = "AD02";
    PlaceTypeKeyEnum["MACROREGION"] = "AD03";
    PlaceTypeKeyEnum["REGION"] = "AD04";
    PlaceTypeKeyEnum["MICROREGION"] = "AD05";
    PlaceTypeKeyEnum["PROVINCE"] = "AD06";
    PlaceTypeKeyEnum["COUNTY"] = "AD07";
    PlaceTypeKeyEnum["MUNICIPALITY"] = "AD08";
    PlaceTypeKeyEnum["BOROUGH"] = "AD09";
    PlaceTypeKeyEnum["MACRO_NEIGHBORHOOD"] = "NBH1";
    PlaceTypeKeyEnum["NEIGHBORHOOD"] = "NBH2";
    PlaceTypeKeyEnum["MICRO_NEIGHBORHOOD"] = "NBH3";
    PlaceTypeKeyEnum["MACRO_STAT_UNIT"] = "STU1";
    PlaceTypeKeyEnum["STATISTICAL_UNIT"] = "STU2";
    PlaceTypeKeyEnum["MICRO_STAT_UNIT"] = "STU3";
    PlaceTypeKeyEnum["STREET"] = "STRT";
    PlaceTypeKeyEnum["BLOCK"] = "BLOC";
    PlaceTypeKeyEnum["PARCEL"] = "PARC";
    PlaceTypeKeyEnum["BUILDING"] = "BILD";
    PlaceTypeKeyEnum["HOUSE_NUMBER"] = "HONU";
})(PlaceTypeKeyEnum || (PlaceTypeKeyEnum = {}));
